__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "platform-policy-management-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@contrast-security-inc/design-system-badges", "0.13.1", () => (Promise.all([__webpack_require__.e(975), __webpack_require__.e(18), __webpack_require__.e(425), __webpack_require__.e(821), __webpack_require__.e(625)]).then(() => (() => (__webpack_require__(6625))))));
			register("@contrast-security-inc/design-system-buttons", "0.5.0", () => (Promise.all([__webpack_require__.e(975), __webpack_require__.e(18), __webpack_require__.e(425), __webpack_require__.e(684)]).then(() => (() => (__webpack_require__(1684))))));
			register("@contrast-security-inc/design-system-data-bars", "4.1.4", () => (Promise.all([__webpack_require__.e(159), __webpack_require__.e(890), __webpack_require__.e(975), __webpack_require__.e(18), __webpack_require__.e(425), __webpack_require__.e(810), __webpack_require__.e(821), __webpack_require__.e(250)]).then(() => (() => (__webpack_require__(3890))))));
			register("@contrast-security-inc/design-system-foundations", "2.2.0", () => (Promise.all([__webpack_require__.e(632), __webpack_require__.e(975), __webpack_require__.e(18)]).then(() => (() => (__webpack_require__(6632))))));
			register("@contrast-security-inc/design-system-tables", "1.7.7", () => (Promise.all([__webpack_require__.e(159), __webpack_require__.e(855), __webpack_require__.e(975), __webpack_require__.e(18), __webpack_require__.e(425), __webpack_require__.e(810), __webpack_require__.e(821), __webpack_require__.e(250), __webpack_require__.e(512)]).then(() => (() => (__webpack_require__(8855))))));
			register("@contrast-security-inc/design-system-typography", "3.0.0", () => (Promise.all([__webpack_require__.e(975), __webpack_require__.e(18), __webpack_require__.e(425), __webpack_require__.e(468)]).then(() => (() => (__webpack_require__(3468))))));
			register("@emotion/css", "11.11.2", () => (__webpack_require__.e(92).then(() => (() => (__webpack_require__(3092))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(669).then(() => (() => (__webpack_require__(9669))))));
			register("camelcase-keys", "7.0.2", () => (__webpack_require__.e(828).then(() => (() => (__webpack_require__(2828))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-intl", "6.1.1", () => (Promise.all([__webpack_require__.e(785), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(3785))))));
			register("react-query", "3.39.2", () => (Promise.all([__webpack_require__.e(767), __webpack_require__.e(975), __webpack_require__.e(810)]).then(() => (() => (__webpack_require__(8767))))));
			register("react-router-dom", "6.6.1", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(9818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			initExternal(8452);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};